(() => {
  if (!('IntersectionObserver' in window)) return;
  const targets = '.sf-card,.sf-media-shell,.ss-tile,.sf-press,.sf-collection-directory>article';
  const observed = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('sf-perf-offscreen', !entry.isIntersecting));
  }, { rootMargin: '200px' });
  function scan(root) {
    if (root.matches?.(targets) && !observed.has(root)) { observed.add(root); observer.observe(root); }
    root.querySelectorAll(targets).forEach(element => {
      if (!observed.has(element)) { observed.add(element); observer.observe(element); }
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(targets).forEach(element => { observer.unobserve(element); observed.delete(element); });
  });
  document.addEventListener('visibilitychange', () => document.documentElement.classList.toggle('sf-perf-background', document.hidden));
})();
